import CreditIcon from '@/assets/payment/credit.svg';
import CreditDarkIcon from '@/assets/payment/credit-dark.svg';
import PayPalIcon from '@/assets/payment/paypal.svg';
import PayPalDarkIcon from '@/assets/payment/paypal-dark.svg';
import GoogleIcon from '@/assets/payment/google.png';
import GoogleDarkIcon from '@/assets/payment/google-dark.png';
import AppleIcon from '@/assets/payment/apple.svg';
import AppleDarkIcon from '@/assets/payment/apple-dark.svg';
import RefreshIcon from '@/assets/payment/change_content.svg';
import RefreshDarkIcon from '@/assets/payment/change_content-dark.svg';
import AchIcon from '@/assets/payment/bank.png';
import SofortIcon from "@/assets/payment/sofort.png";
import FurikomiIcon from "@/assets/payment/customer_balance.png";
import iDEALIcon from "@/assets/payment/ideal.png";
import UsBankAccount from "@/assets/payment/us_bank_account.png";
import KlarnaIcon from "@/assets/payment/klarna.png";
import WiseIcon from "@/assets/payment/wise.png";
import BacsIcon from "@/assets/payment/bacs.png";
import FpsIcon from "@/assets/payment/fps.png";
import OpenBankingIcon from '@/assets/payment/us_bank_account.png';
import TrustlyIcon from '@/assets/payment/trustly.png';
import InteracIcon from '@/assets/payment/interac.png';
import PayIdIcon from '@/assets/payment/payid.png';
import FpxIcon from '@/assets/payment/fpx.png';
import PoliIcon from '@/assets/payment/poli.png';
import PayNowIcon from '@/assets/payment/paynow.png';
import PixIcon from '@/assets/payment/pix.png';
import BoletoIcon from '@/assets/payment/boleto.png';
import DanaIcon from '@/assets/payment/dana.png';
import OvoIcon from '@/assets/payment/ovo.png';
import P24Icon from '@/assets/payment/p24.png';
import SepaIcon from '@/assets/payment/sepa.png';
import UpiIcon from '@/assets/payment/upi.png';

export const payMethodIconMap = {
  CreditCard: CreditIcon,
  CreditCardDark: CreditDarkIcon,
  CreditCardReferenceTransaction: CreditIcon,
  PayPal: PayPalIcon,
  PayPalDark: PayPalDarkIcon,
  AdyenApplePay: AppleIcon,
  AdyenApplePayDark: AppleDarkIcon,
  AdyenGooglePay: GoogleIcon,
  AdyenGooglePayDark: GoogleDarkIcon,
  changeContent: RefreshIcon,
  changeContentDark: RefreshDarkIcon,
  ACH: AchIcon,
  sofort: SofortIcon,
  customer_balance: FurikomiIcon,
  ideal: iDEALIcon,
  us_bank_account: UsBankAccount,
  klarna: KlarnaIcon,
  wise: WiseIcon,
  bacs: BacsIcon,
  fps: FpsIcon,
  openbanking: OpenBankingIcon,
  banktransfer: FurikomiIcon,
  trustly: TrustlyIcon,
  interac: InteracIcon,
  payid: PayIdIcon,
  fpx: FpxIcon,
  poli: PoliIcon,
  paynow: PayNowIcon,
  pix: PixIcon,
  boleto: BoletoIcon,
  dana: DanaIcon,
  ovo: OvoIcon,
  p24: P24Icon,
  sepa: SepaIcon,
  // OBT-1719
  card: CreditIcon,
  UPI: UpiIcon,
};

export const payMethodNameMap = {
  CreditCard: "billing.payment.credit",
  CreditCardReferenceTransaction: "billing.payment.credit",
  PayPal: "billing.payment.paypal",
  AdyenApplePay: "billing.payment.apple_pay",
  AdyenGooglePay: "billing.payment.google_pay",
  sofort: "billing.payment.sofort",
  customer_balance: "billing.payment.customer_balance",
  ideal: "billing.payment.ideal",
  p24: "billing.payment.p24",
  us_bank_account: "billing.payment.us_bank_account",
  klarna: "billing.payment.klarna",
  klarna_de_se: "billing.payment.klarna_de_se",
  bacs: "billing.payment.bacs",
  fps: "billing.payment.fps",
  openbanking: "billing.payment.openbanking",
  banktransfer: "billing.payment.banktransfer",
  trustly: "billing.payment.trustly",
  interac: "billing.payment.interac",
  payid: "billing.payment.payid",
  fpx: "billing.payment.fpx",
  poli: "billing.payment.poli",
  paynow: "billing.payment.paynow",
  pix: "billing.payment.pix",
  boleto: "billing.payment.boleto",
  ovo: "billing.payment.ovo",
  dana: "billing.payment.dana",
  // OBT-1719
  card: "billing.payment.credit",
  upi: "billing.payment.upi",
  // Items below are working for the Google Analytics tracking
  "apm-sofort": "sofort",
  "apm-customer_balance": "furikomi",
  "apm-ideal": "ideal",
  "apm-us_bank_account": "us ach direct debit",
  "apm-klarna": "klarna",
  "apm-p24": "przelewy24",
  "apm-bacs": "wise + bacs",
  "apm-fps": "wise + fps",
  "apm-openbanking": "wise + open banking",
  "apm-banktransfer": "wise + bank transfer",
  "apm-trustly": "wise + trustly",
  "apm-interac": "wise + interac",
  "apm-payid": "wise + payid",
  "apm-fpx": "wise + fpx",
  "apm-poli": "wise + poli",
  "apm-paynow": "wise + paynow",
  "apm-pix": "wise + pix",
  "apm-boleto": "wise + boleto",
  "apm-ovo": "wise + ovo",
  "apm-dana": "wise + dana",
  // OBT-1719
  "apm-card": "card"
}

export const payMethodClassNameMap = {
  CreditCard: "credit-card",
  CreditCardReferenceTransaction: "credit-card",
  PayPal: "paypal",
  AdyenApplePay: "apple-pay",
  AdyenGooglePay: 'google-pay',
  ACH: 'ach',
  sofort: "sofort",
  customer_balance: "customer_balance",
  ideal: "ideal",
  us_bank_account: "us_bank_account",
  klarna: "klarna",
  p24: "p24",
  bacs: "bacs",
  fps: "fps",
  openbanking: "openbanking",
  banktransfer: "banktransfer",
  trustly: "trustly",
  interac: "interac",
  payid: "payid",
  fpx: "fpx",
  poli: "poli",
  paynow: "paynow",
  pix: "pix",
  boleto: "boleto",
  ovo: "ovo",
  dana: "dana",
  // OBT-1719
  card: "credit-card",
  UPI: 'upi',
}

export const payMethodMap = {
  credit: 'CreditCard',
  creditByIndia: 'CreditCardReferenceTransaction',
  paypal: 'PayPal',
  google: 'AdyenGooglePay',
  apple: 'AdyenApplePay',
  ach: 'ACH',
  sepa: 'BankTransfer',
  // OBT-1719
  card: 'CreditCardBackupByAPM',
  upi: 'UPI',
};

export const nonElectronicPayMethodMap = {
  cash: 'Cash',
  check: 'Check',
  other: 'Other',
  wireTransfer: 'WireTransfer',
  bankTransfer: 'BankTransfer'
}

export const payMethodRefreshKey = "refresh";

export const STRIPE_APM_OPTIONS = {
  Sofort: 'sofort',
  iDEAL: 'ideal',
  UsAchDirectDebit: 'us_bank_account',
  Furikomi: 'customer_balance',
  Klarna: 'klarna',
  P24: 'p24'
}

export const HPM_ERROR_MAPPING = {
  'errorField_creditCardExpirationMonth': 'invalid_expiry_year',
  'errorField_creditCardExpirationYear': 'invalid_expiry_year',
  'errorField_creditCardType': 'card_not_supported',
  'errorField_creditCardNumber': 'invalid_number',
  'errorField_cardSecurityCode': 'invalid_cvc',
  'errorField_creditCardHolderName': 'invalid_account',
};

export const HPM_CUSTOMIZE_FIELDS = ['creditCardNumber','cardSecurityCode','creditCardExpirationMonth','creditCardExpirationYear','creditCardState','creditCardHolderName']

export const ERROR_MAPPING = {
  DEFAULT: {
    'Missing Field': 'billing.missing_field',
    'Invalid Card Number': 'error.billing.stripe.incorrect_number',
    'Invalid card number': 'error.billing.stripe.incorrect_number',
    'Expiration date must be a future date': 'error.billing.stripe.invalid_expiry_month',
    'invalid_request': 'error.billing.stripe.generic_error',
    'authentication_required': 'error.billing.stripe.authentication_required',
    'approve_with_id': 'error.billing.stripe.approve_with_id',
    'call_issuer': 'error.billing.stripe.call_issuer',
    'card_not_supported': 'error.billing.stripe.card_not_supported',
    'card_velocity_exceeded': 'error.billing.stripe.card_velocity_exceeded',
    'currency_not_supported': 'error.billing.stripe.currency_not_supported',
    'do_not_honor': 'error.billing.stripe.do_not_honor',
    'do_not_try_again': 'error.billing.stripe.do_not_try_again',
    'expired_card': 'error.billing.stripe.expired_card',
    'fraudulent': 'error.billing.stripe.fraudulent',
    'generic_decline': 'error.billing.stripe.generic_decline',
    'incorrect_number': 'error.billing.stripe.incorrect_number',
    'incorrect_cvc': 'error.billing.stripe.incorrect_cvc',
    'incorrect_pin': 'error.billing.stripe.incorrect_pin',
    'incorrect_zip': 'error.billing.stripe.incorrect_zip',
    'insufficient_funds': 'error.billing.stripe.insufficient_funds',
    'invalid_account': 'error.billing.stripe.invalid_account',
    'invalid_amount': 'error.billing.stripe.invalid_amount',
    'invalid_cvc': 'billing.error.zuora_required_cvv',
    'invalid_expiry_year': 'error.billing.stripe.invalid_expiry_year',
    'invalid_number': 'billing.error.zuora_invalid_cc',
    'invalid_pin': 'error.billing.stripe.invalid_pin',
    'issuer_not_available': 'error.billing.stripe.issuer_not_available',
    'lost_card': 'error.billing.stripe.lost_card',
    'merchant_blacklist': 'error.billing.stripe.merchant_blacklist',
    'new_account_information_available': 'error.billing.stripe.new_account_information_available',
    'no_action_taken': 'error.billing.stripe.no_action_taken',
    'not_permitted': 'error.billing.stripe.not_permitted',
    'offline_pin_required': 'error.billing.stripe.offline_pin_required',
    'online_or_offline_pin_required': 'error.billing.stripe.online_or_offline_pin_required',
    'pickup_card': 'error.billing.stripe.pickup_card',
    'pin_try_exceeded': 'error.billing.stripe.pin_try_exceeded',
    'processing_error': 'error.billing.stripe.processing_error',
    'reenter_transaction': 'error.billing.stripe.reenter_transaction',
    'restricted_card': 'error.billing.stripe.restricted_card',
    'revocation_of_all_authorizations': 'error.billing.stripe.revocation_of_all_authorizations',
    'revocation_of_authorization': 'error.billing.stripe.revocation_of_authorization',
    'security_violation': 'error.billing.stripe.security_violation',
    'service_not_allowed': 'error.billing.stripe.service_not_allowed',
    'stolen_card': 'error.billing.stripe.stolen_card',
    'stop_payment_order': 'error.billing.stripe.stop_payment_order',
    'testmode_decline': 'error.billing.stripe.testmode_decline',
    'transaction_not_allowed': 'error.billing.stripe.transaction_not_allowed',
    'try_again_later': 'error.billing.stripe.try_again_later',
    'withdrawal_count_limit_exceeded': 'error.billing.stripe.withdrawal_count_limit_exceeded',
    'card_decline_rate_limit_exceeded': 'error.billing.stripe.card_decline_rate_limit_exceeded',
    'emptyField': 'billing.required',
    'emptyField_creditCardNumber': 'billing.error.zuora_required_cc',
    'emptyField_cardSecurityCode': 'billing.error.zuora_required_cvv',
    'emptyField_creditCardExpirationMonth': 'billing.error.zuora_required_expiration_date',
    'emptyField_creditCardExpirationYear':  'billing.error.zuora_required_expiration_date',
    'emptyField_creditCardHolderName':'billing.error.zuora_required_card_holder_name',
    'emptyField_creditCardState':'billing.error.zuora_required_state',
    'invalid_creditCardNumber': 'billing.error.zuora_invalid_cc',
    'missingFullAddress': 'billing.enter_full_address',
    'invalidEmail': 'billing.invalid',
    'invalidVAT': 'billing.invalid',
    'invalidCC': 'billing.invalid',
    'invalidCVV': 'billing.invalid',
    'invalidCoupon': 'billing.invalid',
    'cardDeclined': 'billing.transaction_declined',
    'acceptTOS': 'billing.accept_terms_of_service',
    'invalidQuantity': 'billing.invalid_quantity',
    'invalidZip': 'billing.invalid_zip',
    'invalidJPZip': 'billing.invalid_jp_zip',
    'invalidINZip': 'billing.invalid_in_zip',
    'notEuropeanCountry': 'billing.not_european_country',
    'creditCardExpirationMonth': 'billing.expirationDate',
    'creditCardExpirationYear': 'billing.expirationDate',
    'cardSecurityCode': 'billing.cvv',
    'creditCardNumber': 'billing.credit_card_number',
    'creditCardHolderName': 'billing.card_hold_name',
    'specialCharacters': 'billing.enter_special_characters',
  },
  Adyen: {
    'Transaction declined.905_3': 'error.billing.adyen.currency_not_supported',
    'Transaction declined.103': 'error.billing.adyen.invalid_cvc',
    'Transaction declined.39': 'error.billing.adyen.invalid_request',
    'Transaction declined.38': 'error.billing.adyen.invalid_request',
    'Transaction declined.37': 'error.billing.adyen.invalid_request',
    'Transaction declined.36': 'error.billing.adyen.merchant_blacklist',
    'Transaction declined.35': 'error.billing.adyen.invalid_request',
    'Transaction declined.34': 'error.billing.adyen.invalid_request',
    'Transaction declined.33': 'error.billing.adyen.do_not_try_again',
    'Transaction declined.32': 'error.billing.adyen.incorrect_zip',
    'Transaction declined.31': 'error.billing.adyen.issuer_not_available',
    'Transaction declined.29': 'error.billing.adyen.withdrawal_count_limit_exceeded',
    'Transaction declined.28': 'error.billing.adyen.insufficient_funds',
    'Transaction declined.27': 'error.billing.adyen.generic_decline',
    'Transaction declined.26': 'error.billing.adyen.offline_pin_required',
    'Transaction declined.25': 'error.billing.adyen.not_permitted',
    'Transaction declined.24': 'error.billing.adyen.expired_card',
    'Transaction declined.23': 'error.billing.adyen.online_or_offline_pin_required',
    'Transaction declined.22': 'error.billing.adyen.invalid_request',
    'Transaction declined.21': 'error.billing.adyen.invalid_request',
    'Transaction declined.20': 'error.billing.adyen.invalid_account',
    'Transaction declined.19': 'error.billing.adyen.invalid_request',
    'Transaction declined.18': 'error.billing.adyen.pickup_card',
    'Transaction declined.17': 'error.billing.adyen.incorrect_pin',
    'Transaction declined.16': 'error.billing.adyen.invalid_request',
    'Transaction declined.15': 'error.billing.adyen.invalid_request',
    'Transaction declined.14': 'error.billing.adyen.call_issuer',
    'Transaction declined.12': 'error.billing.adyen.card_velocity_exceeded',
    'Transaction declined.11': 'error.billing.adyen.invalid_request',
    'Transaction declined.10': 'error.billing.adyen.card_not_supported',
    'Transaction declined.9': 'error.billing.adyen.lost_card',
    'Transaction declined.8': 'error.billing.adyen.incorrect_number',
    'Transaction declined.7': 'error.billing.adyen.invalid_amount',
    'Transaction declined.6': 'error.billing.adyen.incorrect_cvc',
    'Transaction declined.5': 'error.billing.adyen.do_not_honor',
    'Transaction declined.4': 'error.billing.adyen.approve_with_id',
    'Transaction declined.3': 'error.billing.adyen.new_account_information_available',
    'Transaction declined.2': 'error.billing.adyen.no_action_taken',
    'Transaction declined.Refused': 'error.billing.adyen.enter_valid_upi_id',
    'vpa': 'error.billing.adyen.vpa',
  },
  INR: {
    'transaction_not_allowed': 'error.billing.stripe.transaction_not_allowed_inr',
  },
};

export const INR_ERROR_MAPPING = {
  'user data for the account': 'billing.unknown_error_try_again',
};

export const legacyCreditCardGateWay = 'CybersourceL2USD';

export const paymentGatewayMap = {
  Adyen: 'Adyen',
  Stripe: 'Stripe',
  PayPal: 'PayPal',
  Wise: 'Wise'
}

export const PaymentComponentName = 'Payment';

export const integrationTypeMap = {
  APM: 'APM',
  PayWithCC: 'PayWithCC',
  ApplePay: 'ApplePay',
  PayWithGoogle: 'PayWithGoogle',
  PayWithUpi: 'PayWithUpi',
}

export const achVerifyStatusMap = {
  pending: 'pending',
  retryExceeded: 'verify_retries_exceeded',
  accountVerificationFailed: 'account_verification_failed',
  verifyFirstAttemptFailed: 'verify_first_attempt_failed',
  verifySecondAttemptFailed: 'verify_second_attempt_failed'
}

export const HpmValidationErrorMap = {
  Attempt_Exceed_Limitation: 'Attempt_Exceed_Limitation',
  Invalid_Security: 'Invalid_Security',
};

export const needCheckCreditFormFieldList = ["creditCardState", "creditCardCity", "creditCardCountry"];

export const nonPayPalCurrencyList = ['IDR', 'INR', 'KRW', 'MYR', 'VND', 'SAR', 'ZAR', 'AED'];

export const WISE = 'wise'

export const P24 = 'p24'

export const APM = 'APM'

export const WISE_SUCCESS_URL = '/apm/wise/success'

export const WISE_UPGRADE_SUCCESS_URL = '/apm/wise/payment/success?flow=update'

export const APM_PAYMENT_STATUS_SUCCEEDED = 'succeeded'

export const APM_PAYMENT_STATUS_PROCESSING = 'processing'

export const bankTransferTypes = {
  sepa: 'SEPA'
}

export const APM_BACKUP_CC = 'card'

export const APM_ROUTE_PATH = {
  UPDATE: 'update',
  CHECKOUT: 'checkout'
}

export const mandatePaymentTypeKey = {
  CARD: 'card',
  BANK: 'bank',
}

// Same types in APM Project: fe-billing-apm /src/store/const.ts
export const EMBED_POST_MESSAGE_TYPES = {
  FORM_INIT: 'apm_embed/form_init',
  FORM_LOADED: 'apm_embed/form_loaded',
  FORM_INCOMPLETE: 'apm_embed/form_incomplete',
  FORM_COMPLETE: 'apm_embed/form_complete',
  FORM_SUBMIT: 'apm_embed/form_submit',
  OPC_BUY_SUBMITTING: 'apm_embed/opc_buy_submitting',
  SUCCESS: 'apm_embed/success',
  ERROR: 'apm_embed/error',
  CLOSED: 'apm_embed/closed'
};

export const KLARNA_PAYMENT_OPTIONS = {
  PAY_IN_INSTALLMENTS: 'pay_in_installments',
  PAY_LATER: 'pay_later',
  PAY_NOW: 'pay_now',
  PAY_WITH_FINANCING: 'pay_with_financing',
}
